module.exports = __webpack_public_path__ + "static/media/suit-1.389ce91c.jpg";